// extracted by mini-css-extract-plugin
export default {"firstBlock":"about_firstBlock__UKRFx","serviceInfo":"about_serviceInfo__q0gpB","instructions":"about_instructions__+vE3r","result":"about_result__tEByy","intro":"about_intro__0olqK"};